import { render, staticRenderFns } from "./HeaderHomePage.vue?vue&type=template&id=197bc8f6&scoped=true&lang=pug"
import script from "./HeaderHomePage.vue?vue&type=script&lang=js"
export * from "./HeaderHomePage.vue?vue&type=script&lang=js"
import style0 from "./HeaderHomePage.vue?vue&type=style&index=0&id=197bc8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197bc8f6",
  null
  
)

export default component.exports